import styled from 'styled-components';

import { apx } from '../../../../contrib/ui';

export const ClubPlayerRosterStyled = styled.div`
  .titles-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${apx(10)};

    .total-label {
      font-family: 'DINNextLTPro-Heavy';
      text-transform: uppercase;
      position: relative;
      top: ${apx(2)};
      margin-right: 0.2em;
      margin-left: auto;
      font-size: ${apx(22)};
      color: var(--dark);
    }

    .total-value {
      height: ${apx(40)};
      width: ${apx(65)};
      border-radius: ${apx(5)};
      background-color: var(--greydd);
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: ${apx(5)};
      font-size: ${apx(22)};
      font-family: 'DINNextLTPro-Heavy';
      color: var(--dark);
    }

    .lookup {
      & > div {
        margin: 0 !important;

        .material-input {
          margin-top: 0 !important;
          width: ${apx(380)};
          height: ${apx(40)};
        }

        p.form-helper-text {
          display: none;
        }
      }
    }
  }

  .action-buttons {
    justify-content: flex-end;
    .button {
      margin: 0;
      margin-left: 1em;
      width: initial;
      min-width: ${apx(172)};
    }
  }

  .checkbox-wrapper {
    flex: none;
    text-align: center;
    width: ${apx(60)};
    & > span {
      padding: 0;
    }
  }

  .mini-tag {
    height: ${apx(30)};
    width: ${apx(60)};
    border-radius: ${apx(5)};
    background-color: var(--grey9b);
    color: white;
    font-family: 'DINNextLTPro-Bold';
    font-size: ${apx(16)};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
